import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { HeroImage } from "../shared/hero-image";
import StoryCard from "../shared/story-card";
import Breadcrumb from "../shared/breadcrumbs";
import styles from "../text-story-page/styles.m.css";

import { VikatanResponsiveContainer } from "../../../../rows/ad-free";
import StoryMidPromotion from "../../storyMidContent";
import stylesLongForm from "./styles.m.css";
import { humanizeDate } from "../../../../utils/time-format";
import { Link } from "@quintype/components";
import Icon from "../../../../atoms/icon";
import { fetchvuuklegetCommentCount } from "../../../../../api";

function LongFormStory(props) {
  const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
  const renderarticleFooter = get(props, ["renderarticleFooter"], () => null);
  const renderFooter = get(props, ["renderFooter"], () => null);
  const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
  const section = get(props, ["story", "sections", "0"], null);
  const storyHeadline = get(props, ["story", "subheadline"], () => null);
  const renderRelatedArticle = get(props, ["renderRelatedArticle"], () => null);
  const singleCard = get(props, ["story", "cards"], null);
  const storyId = get(props, ["story", "id"], "");

  const readMore = false;
  const cards = readMore ? singleCard.slice(0, 1) : singleCard;
  const cardLength = cards.length;

  const [showShare, setShowShare] = useState(false);
  const expandComments = get(props, ["expandComments"], () => null);
  const [commentsCount, setCommentsCount] = useState(null);

  const handleShareClick = () => {
    setShowShare(!showShare);
  };

  const scrollToComments = () => {
    expandComments();
    const commentsWidgetContainer = document.getElementById("commentsWidgetContainer");
    if (commentsWidgetContainer) {
      commentsWidgetContainer.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    fetchvuuklegetCommentCount(storyId)
      .then(res => {
        setCommentsCount(res.data);
      })
      .catch(error => {
        console.error("Error fetching comments count:", error);
      });
  }, []);

  return (
    <div className={`page-content`}>
      <div className={`container ${stylesLongForm["story-grid"]} `}>
        <Breadcrumb subSection={section} config={props.config} />
        <div className={styles["main-content"]}>
          <article className={`${stylesLongForm["story-body"]} js-story`}>
            <div className={`${stylesLongForm["sticky-socialshare"]} hidden-mobile`}>
              {!readMore && renderSocialMedia("", true)}
            </div>
            {renderHeaderCard()}
            <p className={`${styles["subheadline"]} subheadline-main`}>{storyHeadline}</p>
            <div className={styles["published-time-wrap"]}>
              {story["first-published-at"] && (
                <span className={styles["published"]}>
                  Published:
                  <time className={styles.time} dateTime={new Date(story["first-published-at"]).toISOString()}>
                    {humanizeDate(story["first-published-at"], "relative")}
                  </time>
                </span>
              )}
              {story["last-published-at"] && (
                <span className={styles["updated"]}>
                  Updated:
                  <time className={styles.time} dateTime={new Date(story["last-published-at"]).toISOString()}>
                    {humanizeDate(story["last-published-at"], "relative")}
                  </time>
                </span>
              )}
            </div>
            {readMore ? (
              <HeroImage story={props.story} className={styles["hero-image"]} icon="longform" headline="Long Form" />
            ) : (
              <HeroImage story={props.story} className={styles["hero-image"]} icon="longform" headline="Long Form" />
            )}

            <div className={styles["audio-share-wrapper"]}>
              <div className={styles["audio-comments-share"]}>
                <div>
                  <Link
                    href="https://whatsapp.com/channel/0029Va7F0Hj0bIdoYCCkqs41"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles["box-div"]}
                  >
                    <Icon type="icon-whatsapp" className={styles["whatsapp-channel-icon"]} />
                    <span className={styles["channel-txt"]}>Join Our Channel</span>
                  </Link>
                  {/* <Link
                    href="https://bit.ly/3J0OoJc"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${styles["box-div"]} ${styles["play-to-win"]}`}
                    style={{ padding: "0" }}
                  >
                    <img src="https://media.vikatan.com/vikatan/2024-03/2455867c-ef84-491e-be25-abd7a1e00de2/Play_to_win.gif" />
                  </Link> */}
                </div>

                <div className={styles["box-div"]} onClick={scrollToComments}>
                  <Icon type="comment" />
                  <span className={styles["channel-txt"]}>
                    {commentsCount !== null ? commentsCount[storyId] || 0 : 0}
                  </span>
                  <span className={`${styles["channel-txt"]} hidden-mobile`}>Comments</span>
                </div>
                <div
                  className={`${styles["box-div"]} ${showShare ? styles["share-active"] : ""} `}
                  onClick={handleShareClick}
                >
                  <Icon type="socialshare" />
                  <span className={`${styles["channel-txt"]} hidden-mobile`}>Share</span>
                </div>
              </div>

              <div className={styles["social-share-wrapper"]}>
                {showShare && !readMore && renderSocialMedia("", false)}
              </div>
            </div>

            {cards &&
              cards.map((card, index) => {
                return (
                  <React.Fragment key={card.id}>
                    <VikatanResponsiveContainer
                      placement={"text-story"}
                      adtype={parseInt(index + 1)}
                      storyId={props.story.id}
                      className="ad_300_250"
                      story={props.story}
                    />

                    {index === 1 && (
                      <div>
                        <StoryMidPromotion story={props.story} />
                      </div>
                    )}

                    <StoryCard
                      card={card}
                      story={props.story}
                      showCard={readMore}
                      className={stylesLongForm["story-card"]}
                      cardLength={cardLength}
                      renderRelatedArticle={renderRelatedArticle}
                      config={props.config}
                    />
                  </React.Fragment>
                );
              })}

            <div id="we-story-end" />
            <div id="commentsWidgetContainer">{renderarticleFooter(readMore)}</div>
          </article>
          {renderFooter(readMore)}
        </div>
        {/* {renderSidebar()} */}
      </div>
    </div>
  );
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any
});
LongFormStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func
};

export { LongFormStory };
